import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { Card, CardContent, Typography, Grid } from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import { CommonConfig } from '../../config/common-config';
import token from '../../config/token';
// import ButtonComp from '../../components/button/index';
import LoaderPopUp from '../../components/loaderpopup/loader';
import SuccessPopUp from '../../components/loaderpopup/success';
import ErrorPopUp from '../../components/loaderpopup/error';

export default function RenameTeam() {
    const tokens = token();
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const [AllRolesNames, setAllRolesNames] = useState([]);
    const [newArr, setNewArr] = useState([]);
    const apiurl = `${CommonConfig.dev.baseUrl}/api/auth/tbl-roles-alias/${tennantDetails.tennantName}`;
    const [showLoaderSubmit, setShowLoaderSubmit] = useState(false);
    const [openBox, setOpenBox] = useState(false);    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const axiosConfig = {
        headers: {
            Authorization: bearerToken,
        },
    };
    const [reRender, setreRender] = useState(false);
    const handleClose = () => {
        setShowLoaderSubmit(false);
    };
    useEffect(() => {
        axios
            .get(apiurl,tokens, axiosConfig)
            .then((response) => {
                let tempArr = [];
                response.data.filter((ele)=> {
                    if(ele.id !== 25 && ele.id !== 26){
                        tempArr.push(ele);
                    }
                })
                console.log("RERENDER", tempArr);
                setAllRolesNames(tempArr);
                setNewArr(tempArr);
                ////console.log("RERENDER");
            })
            .catch((error) => {
                //console.log(error);
            });
    }, [tennantDetails,tokens, bearerToken,reRender]);

    const UpdateRename = () => {
        setShowLoaderSubmit(true);
        axios
            .put(apiurl, newArr,tokens, axiosConfig)
            .then((response) => {
                setreRender(!reRender)
                        setShowLoaderSubmit(false);
                        setSuccessPop(true);
                    setTimeout(() => {
                        setSuccessPop(false);
                    }, 2500);

            })
            .catch((error) => {
                const errResult = error.response;
                    if (errResult.data) {
                            setShowLoaderSubmit(false);
                            setErrorPop(true);
                        setTimeout(() => {
                            setErrorPop(false);
                        }, 5000);
                        setErrorMsgGenerateRecceipt(errResult.data.message);
                }
            });
    };

    const getRolesList = () => {
        const list = AllRolesNames.map((rolesData, ind) => (
            <Grid item xs={12} sm={6} key={rolesData.roleAlias}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" shrink>
                        Role Name ({rolesData.roleText})
                    </InputLabel>
                    
                    <Input
                        type="text"
                        key={rolesData.roleAlias}
                        className="bottom"
                        placeholder="Alias Name"
                        defaultValue={rolesData.roleAlias}
                        onChange={(e) => {
                            let value = e.target.value ? e.target.value : rolesData.roleText;
                            setNewArr((val, i) => {
                                val[ind] = { id: rolesData.id, roleAlias: value };
                                return val;
                            });
                        }}
                    />
                </FormControl>
            </Grid>
        ));

        return list;
    };

    return (
        <>
     { successpop ? (  
           <SuccessPopUp open={successpop} showSuccess={successpop} handleClose={handleClose} title="Alias names updated successfully" />) : null} 
        { errorpop ? (  
           <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose}  title={errorMsgGenerateRecceipt} />) : null}     

            <Card className="client-card">
                <CardContent className="client-heading">
                    <Typography variant="h5">Rename Team</Typography>
                </CardContent>
                <CardContent>
                    <Grid container spacing={3} className="main-container">
                        {getRolesList()}
                    </Grid>
                </CardContent>
            </Card>
            {(showLoaderSubmit ? <LoaderPopUp showLoader={showLoaderSubmit} handleClose={handleClose} title="Please wait while we submit"/> : null) }
               
            <Grid>
           <div className="footer-button">
                  <Button
                    className="btnBluepop"
                    onClick={(e) => {
                        e.preventDefault();
                        //console.log('new Arr', JSON.stringify(newArr));
                        UpdateRename();
                    }}
                    >
                        Submit
                    </Button>
                </div>
            </Grid>
            
        </>
    );
}
